import { createSelector, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { createBaseSelector, registerSlice } from "shared/lib/redux";
import { SeaSavedCardModel } from "./model";

type SeaSavedCard = SeaSavedCardModel[];

const initialAppState: SeaSavedCard = [];

const seaSavedCardSlice = createSlice({
  name: "seaSavedCards",
  initialState: initialAppState,
  reducers: {
    setSavedCardsAction: (_, action: PayloadAction<SeaSavedCardModel[]>) => {
      return action.payload;
    },
    prependSavedCardAction: (
      state,
      { payload: { data, unique = true } }: PayloadAction<{ data: SeaSavedCardModel; unique?: boolean }>
    ) => {
      if (unique) {
        const foundCard = state.find((card) => card.reference === data.reference);
        if (foundCard) return;
      }
      state.unshift(data);
    },
    appendSavedCardsAction: (
      state,
      { payload: { data, unique = true } }: PayloadAction<{ data: SeaSavedCardModel[]; unique?: boolean }>
    ) => {
      if (unique) {
        const referencesSet = new Set<string>();
        state.forEach((item) => {
          if (item.reference) {
            referencesSet.add(item.reference);
          }
        });

        data.forEach((item) => {
          if (item.reference && !referencesSet.has(item.reference)) {
            state.push(item);
          }
        });
        return state;
      }
      return state.concat(data);
    },
    removeSavedCardAction: (state, action: PayloadAction<SeaSavedCardModel>) => {
      return state.filter((card) => card.reference !== action.payload.reference);
    },
    updateSavedCardAction: (state, action: PayloadAction<SeaSavedCardModel>) => {
      const targetCard = state.findIndex((card) => card.reference === action.payload.reference);
      if (targetCard !== -1) {
        state[targetCard] = action.payload;
      }
    },
  },
});

const seaSavedCardBaseSelector = createBaseSelector(seaSavedCardSlice);

registerSlice([seaSavedCardSlice]);

export const seaSavedCardStore = {
  actions: seaSavedCardSlice.actions,
  selectors: {
    savedCards: createSelector(seaSavedCardBaseSelector, (s) => s),
  },
};
